import type { DynaVault } from '../../../../api/DynaVaultsAPI';

type VaultDepositStatus = Pick<DynaVault, 'isClosed'>;

export const canDepositIntoVault = (
  vault?: VaultDepositStatus | null
): boolean => Boolean(vault && !vault.isClosed);
